<template>
  <billing-report-panel
    report-key="appeals-status"
    route="/reports/billing-appeals-status"
    file-name="recursos-e-recuperacao.xlsx"
    period-label="Período do recurso"
    :columns="columns"
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Situação',
        'Convênio',
        'Lote',
        'Recurso',
        'Rodada',
        'Itens',
        'Datas de recurso, envio e resposta',
        'Recursado',
        'Recuperado',
        'Recuperação %',
      ],
    };
  },
};
</script>
